const emailRegExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

function hasObviousPattern(email) {
  const [local, domain] = email.split('@')
  if (!local || !domain) return true
  const cleanLocal = local.toLowerCase().replace(/[^a-z0-9]/g, '')
  const domainName = domain.split('.')[0].toLowerCase()

  // Local part com 3+ chars iguais consecutivos
  if (/(.)\1{2,}/.test(cleanLocal)) return true
  // Dominio antes do TLD todo repetido
  if (domainName && /^(.)\1+$/.test(domainName)) return true
  // Local e dominio iguais
  if (cleanLocal === domainName && cleanLocal.length > 0) return true

  return false
}

export const validEmail = (data) => {
  if (!emailRegExp.test(data)) return false
  if (hasObviousPattern(data)) return false
  return true
}
